import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppSettingsUrl } from '../../../appSettings';
import { LocalStorageService } from 'src/app/services';
import { IPlan, PlanService } from 'src/app/services/plan.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AmbasadorKeeper, IAmbassador } from 'src/helper/ambassadorKeeper'; 
import { DefaultPriceModel } from './components/default-plan/default-plan.component';
import { DurationType, Repetition } from '../../../services/external/config/plans';




@Component({
    selector: 'landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.less']
})
export class LandingComponent implements OnInit {
    mobileMenuShow: boolean = false;

    defaultPriceModel: DefaultPriceModel = {
        plans: [],
        userPlan: []
    };
    durationTypes: any = DurationType;
    repetitionTypes: any = Repetition;
    @ViewChild('subscription') subsciptionEl: ElementRef;
    refidState: boolean = false;
    plansLoaded: boolean = false;

    ambasador: IAmbassador = null;
    hasAmbasador: boolean = false;
    hasJsonPlan: boolean = false;

    ambasadorCollection: IAmbassador[] = [];

    contactEmail: string;
    contactDiscord: string;
    contactTelegram: string;

    constructor(private plan: PlanService,
        private storage: LocalStorageService,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        const ambasador = new AmbasadorKeeper(window);
        this.hasAmbasador = ambasador.hasCurrentAmbassador();
        this.ambasadorCollection = ambasador.getAll();
        if (this.hasAmbasador)
            this.ambasador = ambasador.getAmbassador();

        if(this.ambasador)
            this.hasJsonPlan = !!this.ambasador.planJson;

        this.contactEmail = this.ambasador?.email ?? 'support@marktools.net';
        this.contactDiscord = this.ambasador?.email ?? AppSettingsUrl.DiscordLink;
        this.contactTelegram = this.ambasador?.telegram ?? 'marktools_support';
    }

    ngOnInit() {
        const refId = this.activatedRoute.snapshot.params['refid'];
        if (refId)
            this.refidState = true;
        if (!this.hasAmbasador) {
            this.plansLoaded = true;
            return;
        }
        // let refId = this.refidState ? this.storage.getData("refid", true) : null;
        this.plan.getPlans(refId).subscribe(s => {            

            this.defaultPriceModel = {
                userPlan: s.filter(s => s.forPromo),
                plans: s.filter(s => !s.forPromo)
            }; 
            this.plansLoaded = true;
            //this.updateView();
        });
    }
    public static scrollTo(id: string, smooth: boolean) {
        const el = document.getElementById(id);
        let top = 0;
        if (el != null)
            top = el.getBoundingClientRect().top;
        window.scrollTo({
            left: 0,
            top: top,
            behavior: smooth ? 'smooth' : 'auto'
        })
    }

    private updateView() {
        if (!this.refidState || !this.plansLoaded)
            return;
        this.plansLoaded = false;
        setTimeout(() => {
            let top = this.subsciptionEl.nativeElement.getBoundingClientRect().top;
            if (top <= 10)
                return;
            LandingComponent.scrollTo('pricing', false);
        });


    }

    ngAfterViewChecked() {
        this.updateView();
    }


    scrollTop() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }

    checked = (event: Event) => {
        let val = event.target as HTMLInputElement;
        if (val.type == 'radio') {
            return;
        }

        console.log(val.className);

        while (val != null && val.className != 'price-choose') {
            val = val.parentNode as HTMLInputElement;
        }

        if (val != null) {
            val = val.firstChild as HTMLInputElement;
            val.checked = true;
        }
    }

    toOffer = () =>
        this.router.navigate(['/'], { fragment: 'offer', skipLocationChange: true });

    toTools = () =>
        this.router.navigate(['/'], { fragment: 'tools', skipLocationChange: true });

}
